import React from 'react';
import { connect } from 'react-redux';
import '../../public/css/OrderHistory.css';
import { dashboardData } from '../dashboard/reducer';
import { ToastContainer, ToastMessage } from '../../lib';
import { injectIntl } from 'react-intl';
import NotFound from '../common/NotFound';
import InfiniteScroll from 'redux-infinite-scroll';
import { FormattedMessage } from 'react-intl';
import { get, uniqueId } from 'lodash';
import defaultMsg from '../../translations/lang/en-US.json';
import OrderHistoryPanel from './components/OrderHistoryPanel';
import OrderHistoryLoader from './components/OrderHistoryLoader';
import { withApollo } from 'react-apollo';
import { compose } from 'recompose';
import { getOrdersHistory } from '../../redux/actions/orderHistoryActions';

const ToastMessageFactory = React.createFactory(ToastMessage.animation);
const AMOUNT_PER_REQUEST = 5;

class CustomerOrderHistory extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ordersHistory: [],
      loadingMore: false,
      hasMoreProp: false,
      ordersFrom: 0,
      scrollPosition: 0
    };
  }

  componentWillMount() {
    if (this.props.userId)
      this.loadUserHistory();
  }

  componentDidUpdate() {
    document.title = `Order History - ${
      this.props.dashboardData.merchantDetails.title
    } - Lavu To Go`;

    //  Keep scroll position after loading new orders
    if(!this.state.loadingMore)
      window.scroll(0, this.state.scrollPosition);
  }

  loadUserHistory = () => {
    this.setState({
      scrollPosition: window.scrollY,
      loadingMore: true,
    });
    const{ userId, client } = this.props;
    const{ ordersFrom } = this.state;
    getOrdersHistory(client, userId, ordersFrom, AMOUNT_PER_REQUEST, this.setCustomerHistoryResult);
  }

  setCustomerHistoryResult = (resp) => {
    const{ ordersFrom, ordersHistory } = this.state;
    let orderData = get(resp, 'data.Customer.orders', []);
      if (orderData && orderData.length > 0) {
        // We have to use actions and reducers to set ordersHistory state instead of a local state.
        // But first we have to fix configureStore.js to don't save all reduxState in localStorage.
        this.setState({
          ordersFrom: ordersFrom + AMOUNT_PER_REQUEST,
          hasMoreProp: true,
          loadingMore: false,
          ordersHistory: ordersHistory.concat(orderData)
        });
      } else {
        this.setState({
          loadingMore: false,
          hasMoreProp: false,
        });
      }
  }

  historyRenderer() {
    let orders = [];
    const { ordersHistory, loadingMore } = this.state;
    if(!loadingMore){
      if(ordersHistory.length > 0){
        orders = ordersHistory.map((order, key) => {
          return order && order.description ? (
            <OrderHistoryPanel key={key} order={order} />
          ) : null;
        });
      } else {
        orders = [
          <div key={uniqueId('noOrdersFound')} className="col-md-8">
            <FormattedMessage
              id="noOrdersFound"
              defaultMessage={defaultMsg.noOrdersFound}
            />
          </div>
        ];
      }
    }
    return orders;
  }

  render() {
    const { userId } = this.props;
    const{ hasMoreProp, loadingMore } = this.state;
    return (
      <div className="fullContent">
        <ToastContainer 
          toastMessageFactory={ToastMessageFactory}
          ref="reorder_container"
          className="toast-top-right"
        />
        {!userId ? (
          <NotFound
            code="401"
            message="It looks you are an invalid user. Please Sign-In to search for your order history. "
          />
        ) : (
          <div className="container cont-style more-space">
            <div className="row">
              <div className="col-md-12">
                <h4>
                  <FormattedMessage 
                    id="orderHistory"
                    defaultMessage={defaultMsg.orderHistory}
                  />
                </h4>
              </div>
              <div className="col-md-10">
                <InfiniteScroll 
                  loader={<OrderHistoryLoader/>}
                  children={this.historyRenderer()}
                  loadMore={this.loadUserHistory}
                  hasMore={hasMoreProp}
                  loadingMore={loadingMore}
                  showLoader={true}
                  threshold={1}
                  containerHeight={'100%'}
                  animateItems={true}
                  elementIsScrollable={false}
                />
              </div>
            </div>
          </div>
        )}
      </div>
    ); 
  }
}

function mapStateToProps(state) {
  return {
    userId: state.auth.loginUserDetails ? state.auth.loginUserDetails.id : 0,
    dashboardData: dashboardData(state),
  };
}

const enhanced = compose(
  withApollo,
  connect(mapStateToProps),
  injectIntl,
);

export default enhanced(CustomerOrderHistory);



// WEBPACK FOOTER //
// ./src/views/CustomerOrderHistory/index.jsx